// Block colour by type. Only these three are styled; any other type a new source
// invents gets the neutral block, so a new source needs no UI change.
export type BlockStyle = "job" | "apartment" | "report" | "neutral";

export function blockStyle(type: string): BlockStyle {
  return type === "job" || type === "apartment" || type === "report" ? type : "neutral";
}
